enum Main {
  CHANNELS,
  FILTER,
  SLIDERS,
  RAILS,
}

export default Main;
